<template>
  <g>
    <path
      fill="#FF7455"
      d="M63 126c34.794 0 63-28.206 63-63S97.794 0 63 0 0 28.206 0 63s28.206 63 63 63z"
    />
    <path
      fill="#fff"
      d="M50.234 57.96V40.397c0-6.991 5.72-12.734 12.683-12.734S75.6 33.406 75.6 40.397V57.96h6.3V40.397C81.9 29.91 73.444 21.42 63 21.42c-10.445 0-18.9 8.49-18.9 18.977V57.96h6.134z"
    />
    <path
      fill="#fff"
      d="M86.483 95.76H39.517c-1.654 0-2.977-1.321-2.977-2.973V59.673c0-1.651 1.323-2.973 2.977-2.973h46.966c1.654 0 2.977 1.322 2.977 2.973v33.114c0 1.652-1.323 2.973-2.977 2.973z"
    />
    <path
      fill="#FF7455"
      d="M63.077 66.78c-2.843 0-5.117 2.331-5.117 5.245 0 1.998 1.137 3.747 2.68 4.58v6.66c0 1.332 1.056 2.415 2.356 2.415 1.3 0 2.355-1.083 2.355-2.415v-6.66c1.625-.916 2.68-2.582 2.68-4.58.163-2.914-2.111-5.245-4.954-5.245z"
    />
  </g>
</template>

<script>
export default {
  name: 'circleLock'
}
</script>

<style scoped></style>
